<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'DRIVER_LEAVES_LIST',
    }"
  >
    <el-form
      status-icon
      :model="ruleForm"
      :rules="rules"
      label-position="top"
      ref="ruleForm"
      label-width="120px"
      v-loading="loading"
      class="carpo-form demo-ruleForm"
    >
      <el-form-item :label="$t('LEAVE_TYPE')" prop="is_hourly">
        <el-select
          :disabled="ruleForm.disabled"
          filterable
          v-model="ruleForm.is_hourly"
          :placeholder="$t('SELECT_PLACEHOLDER')"
        >
          <el-option
            v-for="item in leaveTypes"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('LEAVE_REASON')"
        prop="type.id"
        v-loading="leaveTypeLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          :disabled="ruleForm.disabled"
          :placeholder="$t('SELECT_PLACEHOLDER')"
          v-model="ruleForm.type.id"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in leaveTypeList"
            :key="index"
            :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
            :value="item.id || null"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('DRIVER_TITLE')"
        prop="driver.id"
        v-loading="driverLoading"
        element-loading-spinner="el-icon-loading"
      >
        <el-select
          :disabled="ruleForm.disabled"
          :placeholder="$t('SELECT_PLACEHOLDER')"
          v-model="ruleForm.driver.id"
          clearable
          filterable
        >
          <el-option
            v-for="(item, index) in driversList"
            :key="index"
            :label="item.first_name + ' ' + item.last_name"
            :value="item.id || null"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <div></div>

      <el-form-item
        :label="ruleForm.is_hourly ? $t('DATE_') : $t('START_DATE')"
        prop="start"
      >
        <date-picker
          :disabled="ruleForm.disabled"
          class="el-input__inner"
          v-model="ruleForm.start"
          :locale="$i18n.locale"
          format="jYYYY-jMM-jDD"
          clearable
        />
      </el-form-item>

      <el-form-item
        v-if="!ruleForm.is_hourly"
        :label="$t('END_DATE')"
        prop="stop"
      >
        <date-picker
          :disabled="ruleForm.disabled"
          class="el-input__inner"
          v-model="ruleForm.stop"
          :locale="$i18n.locale"
          format="jYYYY-jMM-jDD"
          clearable
        />
      </el-form-item>

      <el-form-item
        v-if="ruleForm.is_hourly"
        :label="$t('TIME_SELECTION')"
        prop="datetime"
      >
        <el-time-picker
          :disabled="ruleForm.disabled"
          is-range
          v-model="ruleForm.datetime"
          :range-separator="$t('TO')"
          :start-placeholder="$t('START_TIME')"
          :end-placeholder="$t('END_TIME')"
        >
        </el-time-picker>
      </el-form-item>

      <el-form-item
        class="col-span-full"
        :label="$t('description')"
        prop="description"
      >
        <el-input
          :disabled="ruleForm.disabled"
          type="textarea"
          v-model="ruleForm.description"
        ></el-input>
      </el-form-item>

      <FormConfirmation
        v-show="!ruleForm.disabled"
        @resetForm="resetForm('ruleForm')"
        @submitForm="submitForm('ruleForm')"
        :edit="null"
        :loading="submitLoading"
      />
    </el-form>
  </Content>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { gregorianToPersian } from '@/mixins/gregorianToPersian'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import { addDriverLeave, editDriverLeave, driverLeaveType } from '@/api/drivers'
import { driverSummary } from '@/api/drivers'

export default {
  mixins: [resetForm, jalaliToGregorian, gregorianToPersian],
  props: {
    driverLeave: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormConfirmation,
  },
  data() {
    return {
      driversList: [],
      leaveTypeList: [],
      leaveTypeLoading: true,
      driverLoading: true,
      submitLoading: false,

      leaveTypes: [
        {
          value: true,
          label: this.$i18n.t('LEAVE_HOURLY'),
        },
        {
          value: false,
          label: this.$i18n.t('LEAVE_DAY'),
        },
      ],
      ruleForm: {
        start: '',
        stop: '',
        is_hourly: true,
        description: '',
        type: {
          id: null,
        },
        driver: {
          id: null,
        },
        datetime: [
          new Date(2021, 9, 10, 0, 0),
          new Date(2021, 9, 10, 23, 59, 59),
        ],
      },

      rules: {
        start: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('START_DATE'),
            }),
            trigger: 'blur',
          },
        ],
        stop: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('END_DATE'),
            }),
            trigger: 'blur',
          },
        ],
        driver: {
          id: [
            {
              required: true,
              message: this.$i18n.t('REQUIRED_FIELD', {
                type: this.$i18n.t('DRIVER_TITLE'),
              }),
              trigger: 'blur',
            },
          ],
        },
        type: {
          id: [
            {
              required: true,
              message: this.$i18n.t('REQUIRED_FIELD', {
                type: this.$i18n.t('LEAVE_REASON'),
              }),
              trigger: 'blur',
            },
          ],
        },
      },
    }
  },
  watch: {
    driverLeave: {
      handler(val) {
        if (val) {
          this.ruleForm = {
            ...this.ruleForm,
            ...val,
            start: this.gregorianToPersian(val.start),
            stop: this.gregorianToPersian(val.stop),
            datetime: [new Date(val.start), new Date(val.stop)],
          }

          if (this.ruleForm.is_hourly) {
            this.ruleForm.datetime = [new Date(val.start), new Date(val.stop)]
            this.ruleForm.start = this.gregorianToPersian(val.start)
            this.ruleForm.stop = this.gregorianToPersian(val.start)
          } else {
            this.ruleForm.datetime = [
              new Date(2021, 9, 10, 0, 0),
              new Date(2021, 9, 10, 23, 59, 59),
            ]

            this.ruleForm.start = this.gregorianToPersian(val.start)

            this.ruleForm.stop = this.gregorianToPersian(val.stop)
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    setupPayload() {
      // Convert start time to Gregorian
      let startTime = new Date(this.jalaliToGregorian(this.ruleForm.start))
      let stopTime

      if (!this.ruleForm.is_hourly) {
        // If it's not hourly, set stop time to end of day (23:59:59) and start time to beginning of day (00:00:00)
        stopTime = new Date(this.jalaliToGregorian(this.ruleForm.stop))
        stopTime.setHours(23, 59, 59)
        startTime.setHours(0, 0, 0)
      } else {
        // If it's hourly, set stop time to start time
        stopTime = new Date(startTime)
      }

      // Convert start time portion to ISO string
      const startTimePortion = new Date(this.ruleForm.datetime[0])
      startTime.setHours(startTimePortion.getHours())
      startTime.setMinutes(startTimePortion.getMinutes())
      startTime.setSeconds(startTimePortion.getSeconds())

      // Convert stop time portion to ISO string (to ensure consistency)
      const stopTimePortion = new Date(this.ruleForm.datetime[1])
      stopTime.setHours(stopTimePortion.getHours())
      stopTime.setMinutes(stopTimePortion.getMinutes())
      stopTime.setSeconds(stopTimePortion.getSeconds())

      // Convert startTime and stopTime to ISO string
      const startISOString = startTime.toISOString()
      const stopISOString = stopTime.toISOString()

      const payload = {
        start: startISOString,
        stop: stopISOString,
        is_hourly: this.ruleForm.is_hourly,
        description: this.ruleForm.description,
        type: this.ruleForm.type.id,
        driver: this.ruleForm.driver.id,
        id: this.driverLeave != undefined ? this.driverLeave.id : '',
      }

      return payload
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var dispatchFunc =
            this.driverLeave == null ? addDriverLeave : editDriverLeave
          this.submitLoading = true

          dispatchFunc.api(this.setupPayload()).then((res) => {
            this.submitLoading = false
            if (res) {
              this.$notify.success({
                title:
                  this.$t(this.$route.name) +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              if (this.driverLeave == null) this.resetForm(formName)
              else
                this.$router.push({
                  name: 'DRIVER_LEAVES_LIST',
                })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
  },
  created() {
    driverSummary.api().then((res) => {
      if (res) {
        this.driverLoading = false
        this.driversList = res
      }
    })
    driverLeaveType.api().then((res) => {
      if (res) {
        this.leaveTypeLoading = false
        this.leaveTypeList = res
      }
    })
  },
}
</script>
